<template>
	<div class="control-panel-v2" v-bind="config.attrs">
	  <config-style-injector
			  :root-selector="`.control-panel`"
			  :config="config"
	  />
		<component
				v-for="(control, i) in controls"
				:is="control.component"
				:key="control.name + i"
				v-bind="control.attrs"
		/>
	</div>
</template>

<script>
import featureMixin from "@/mixins/featureMixin";
import {controlDictV2, FeatureJsonToComponents} from "@/features/FeatureHelper";
import ConfigStyleInjector from "@/components/style-injector/ConfigStyleInjector.vue";


export default {
	name: "ControlPanelV2",
	components: {ConfigStyleInjector},
	mixins: [featureMixin],
	data() {
		return {
			featurePath: 'header.controlsV2'
		}
	},
	computed: {
		controls() {
			return FeatureJsonToComponents(this.config.items, controlDictV2);
			/*const o = [];
			const dict = controlDict
			// console.log('Controls Dict:', dict)
			for (const name of this.config.items) {
				if (dict[name]) {
					o.push({name, component: dict[name]});
				}
			}
			return o;*/
		}
	}
}
</script>

<style lang="scss">
  [mode="desktop"] {
	.control-panel-v2 {
		& > * {
	    border-right: 1px dashed black !important;
        border-radius: 0;
		padding: 0 11px;
	
     &:hover {
		background: none;
		 span.panel-label {
			color: var(--secondary-color)
		 }
	}
  }
  .zoom-controls.separator-left {
	border-left: 1px dashed black !important;
	
  }
	}
}
[mode="tablet"] ,[mode="mobile"]{
	.control-panel-v2 {
		& > * {
		margin-right: 0.6em;
		}
		div.comp-list-item {
			button, a {
			border: none !important;

			
		}
	}
		button, a {
			border: 1px solid #AFAFAF !important;
			border-radius: 5px !important;

			
			
		}
		.separator-right {
				border-right:1px dashed black;
				padding-left: 10px;
			}
		.panel-label {
		display: none !important;
	}
	
  }
  
}
.control-panel-v2 {
	display: flex;
	align-items: center;
	color: #545454 !important;

	
		span{
			display: block;
			text-align: center;
			color: #545454 ;
			font-size: 14px;
			text-wrap: nowrap;
	}

  & > *:last-child {
	border-right: none !important;
		margin-right: 0;
  }
   button {
	border: none;
	display: flex;
	flex-direction: column;
	

  }

}
</style>
